<template>
  <div class="nx-form-key-value-editor-wrapper">
    <nx-key-value-editor
        :data-vv-name="name"
        :data-vv-scope="scope"
        :data-vv-as="label"
        :title="label"
        :value="parsedValue"
        @input="onInput"
        data-vv-value-path="value"
        v-bind="$attrs"
        v-validate="validation"
    ></nx-key-value-editor>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxKeyValueEditor from '@/components/KeyValue';

export default {
  name: 'nx-form-key-value-editor',
  mixins: [FormElement],
  components: {
    [NxKeyValueEditor.name]: NxKeyValueEditor,
  },
  props: {
    value: {
      type: String,
      default: '[]',
    },
  },
  computed: {
    parsedValue() {
      try {
        const value = JSON.parse(this.value || '[]');
        if (Array.isArray(value)) {
          return value;
        }
        return [];
      } catch (e) {
        return [];
      }
    },
    empty() {
      // Check for falsy
      if (!!this.value === false) {
        return true;
      }
      // Check for empty array string
      if (this.value === '[]') {
        return true;
      }
      return false;
    },
  },
  methods: {
    onInput(value) {
      this.$parentForm.updateField(this.name, JSON.stringify(value));
      this.$emit('input', JSON.stringify(value));
    },
  },
};
</script>
